import { converters as tableConverters } from 'store/table';
import { IEmployeesGroup } from 'types/income';
import { loaders } from './employee-groups.loaders';
import { EmployeeGroup } from './employee-groups.types';

const convertEmployeeGroup = (
  employeesGroup: IEmployeesGroup,
): EmployeeGroup => {
  return {
    id: employeesGroup.id,
    name: employeesGroup.name,
    employeeCount: employeesGroup.employeeCount ?? 0,
    benefitCount: employeesGroup.benefitCount ?? 0,
    benefits: employeesGroup.benefits ?? [],
    isAllEmployeesGroup: employeesGroup.allEmployees,
  };
};

const convertEmployeeGroups = (
  employeesGroups: IEmployeesGroup[],
): EmployeeGroup[] => {
  return employeesGroups.map(convertEmployeeGroup);
};

export const converters = {
  getEmployeeGroups: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getEmployeeGroups>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertEmployeeGroups(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getEmployeeGroup: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getEmployeeGroup>>) => {
    return convertEmployeeGroup(data);
  },
};
